import React, { useEffect, useRef } from 'react';

export default function Size2(props) {
  const { getSize2, setSize2, getSize1, label, location, sizes, isWomens, isSneaker } = props;
  const strings = window.themeStrings || {};
  let previousDelta = 1;
  let nextDelta = 1;

  if (location.code === 'eu') {
    if (isWomens || isSneaker) {
      previousDelta = 2;
    }
    if (!isWomens) {
      nextDelta = 2;
    }
  }

  const sizeIndex = sizes.findIndex(s => s.us === getSize1.us);
  let previousSize = sizes[sizeIndex - previousDelta];
  let nextSize = sizes[sizeIndex + nextDelta];
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      if (!getSize2.us) {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <fieldset className="form-field" ref={ref}>
      <legend className="form-legend">{label}</legend>
      <div className="option-values option-values-one-per-line">
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`size2-0`}
            name="size2"
            value={previousSize.us}
            checked={getSize2.us === previousSize.us}
            onChange={() => setSize2(previousSize)} />
          <label htmlFor={`size2-0`} className="option-value-name">{strings.fit_finder_step2_sometimes_wear.replace('{size}', previousSize[location.code])}</label>
        </div>
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`size2-1`}
            name="size2"
            value={getSize1.us}
            checked={getSize2.us === getSize1.us}
            onChange={() => setSize2(getSize1)} />
          <label htmlFor={`size2-1`} className="option-value-name">{strings.fit_finder_step2_always_wear.replace('{size}', getSize1[location.code])}</label>
        </div>
        <div className="option-value">
          <input
            type="radio"
            className="option-value-input"
            id={`size2-2`}
            name="size2"
            value={nextSize.us}
            checked={getSize2.us === nextSize.us}
            onChange={() => setSize2(nextSize)} />
          <label htmlFor={`size2-2`} className="option-value-name">{strings.fit_finder_step2_sometimes_wear.replace('{size}', nextSize[location.code])}</label>
        </div>
      </div>
    </fieldset>
  );
}